import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Modal from './Modal';
import ProfileDialogContent from './ProfileDialogContent';

export default function ProfileEditDialog({ open, handleClose }) {
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [isOtpScreen, setOtpVerifyScreen] = useState(false);
  return (
    <Modal
      open={open}
      maxWidth="md"
      onClose={handleClose}
      onAction={
        isOtpScreen
          ? () => document.getElementById('verifyOtpButton').click()
          : () => document.getElementById('saveChangeButton').click()
      }
      actionText="Save Changes"
      isBtnLoading={formSubmitting}
    >
      <ProfileDialogContent
        handleClose={handleClose}
        setOtpVerifyScreen={setOtpVerifyScreen}
        setFormSubmitting={setFormSubmitting}
        isOtpScreen={isOtpScreen}
      />
    </Modal>
  );
}

ProfileEditDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func
};
